/**
 * Stage Chatbot View Modal:知識ベース文档内容只读查看。
 *
 * 设计纪律:
 * - 只读 Modal,不做编辑/保存/取消
 * - 复用 globals.css 的 .mv2-modal-* 现有样式(与 mail-v2 风格一致)
 * - manual_text 类型 → 显示 content 原文
 * - wp_post / wp_page 类型(content 为 null)→ 显示占位说明
 *
 * 不做:
 * - 富文本 / Markdown 渲染 / 编辑能力
 * - 修改现有 CRUD 流程
 */

import React from "react";
import type { KnowledgeDocument } from "./api/chatbotApi";

interface KnowledgeViewModalProps {
  open: boolean;
  doc: KnowledgeDocument | null;
  content: string | null;
  loading: boolean;
  error: string | null;
  onClose: () => void;
}

export function KnowledgeViewModal({
  open,
  doc,
  content,
  loading,
  error,
  onClose,
}: KnowledgeViewModalProps) {
  if (!open || !doc) return null;

  const hasContent = content !== null && content !== undefined && content !== "";

  return (
    <div
      className="mv2-modal-backdrop"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={`${doc.title} の本文`}
    >
      <div
        className="mv2-modal"
        style={{ width: 640 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mv2-modal-header">
          <h2>{doc.title}</h2>
          <button
            type="button"
            className="mv2-modal-close"
            onClick={onClose}
            aria-label="閉じる"
          >
            ×
          </button>
        </div>
        <div
          className="mv2-modal-body"
          style={{ display: "flex", flexDirection: "column", gap: 14 }}
        >
          <div>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#6b7280",
                marginBottom: 4,
                letterSpacing: 0.5,
              }}
            >
              タイトル
            </div>
            <div
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: "#111827",
                padding: "8px 10px",
                background: "#f9fafb",
                border: "1px solid #e5e7eb",
                borderRadius: 6,
                wordBreak: "break-word",
              }}
            >
              {doc.title}
            </div>
          </div>

          <div>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#6b7280",
                marginBottom: 4,
                letterSpacing: 0.5,
              }}
            >
              本文
            </div>
            {loading ? (
              <div
                style={{
                  padding: 24,
                  textAlign: "center",
                  color: "#6b7280",
                  fontSize: 13,
                }}
              >
                読み込み中...
              </div>
            ) : error ? (
              <div
                style={{
                  padding: 12,
                  fontSize: 12,
                  color: "#991b1b",
                  background: "#fef2f2",
                  border: "1px solid #fecaca",
                  borderRadius: 6,
                }}
              >
                {error}
              </div>
            ) : hasContent ? (
              <textarea
                readOnly
                value={content ?? ""}
                style={{
                  width: "100%",
                  minHeight: 280,
                  maxHeight: 420,
                  padding: "10px 12px",
                  fontSize: 13,
                  lineHeight: 1.6,
                  color: "#111827",
                  background: "#fff",
                  border: "1px solid #e5e7eb",
                  borderRadius: 6,
                  fontFamily:
                    "ui-monospace, SFMono-Regular, Menlo, monospace",
                  resize: "vertical",
                  outline: "none",
                }}
              />
            ) : (
              <div
                style={{
                  padding: 24,
                  textAlign: "center",
                  color: "#6b7280",
                  fontSize: 13,
                  background: "#f9fafb",
                  border: "1px dashed #d1d5db",
                  borderRadius: 6,
                }}
              >
                本文は保存されていません。
                <br />
                (WP から取り込んだコンテンツは DB に保存されません)
              </div>
            )}
          </div>
        </div>
        <div className="mv2-modal-footer">
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: "6px 14px",
              fontSize: 13,
              fontWeight: 600,
              color: "#fff",
              background: "#2563eb",
              border: "1px solid #2563eb",
              borderRadius: 6,
              cursor: "pointer",
            }}
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
  );
}
